import deleteMeetingAttendee from '@shoflo/studio-redux/actions/attendee/deleteMeetingAttendee';
import toggleProgramSource from '@shoflo/studio-redux/actions/program/toggleProgramSource';
import setProgram from 'actions/Broadcast/program/setProgram';
import removeDesiredAttendeeCamera from '../attendees/removeDesiredAttendeeCamera';
import deleteBroadcastSource from './deleteBroadcastSource';
import { CAMERA_PRESENTER, UNASSIGNED } from '@studio/constants/Sources';

const isCameraPresenter = (source = {}) => source.type === CAMERA_PRESENTER;

/**
 * This action creator handles what side effects should be dispatched when a source is about to be deleted
 * @param {string} sourceId
 * @param {object} deleteParams data to help understand subsequent action to perform
 */
export default (sourceId, deleteParams = {}) => {
  return (dispatch, getState) => {
    const { program, broadcastSources } = getState();
    const [source] = broadcastSources.sources.filter(s => s._id === sourceId);

    if (program) {
      const [layerSource] = program.layers?.filter(
        layer => layer?.source._id === sourceId
      );
      // If source is in Program, update the program.
      if (layerSource) {
        dispatch(toggleProgramSource(source, setProgram));
      }
    }

    if (isCameraPresenter(source)) {
      // remove attendee camera status
      dispatch(removeDesiredAttendeeCamera(source.value));
    }

    dispatch(deleteBroadcastSource(sourceId, deleteParams));

    // delete attendee from meeting
    if (source.type === CAMERA_PRESENTER && source.value !== UNASSIGNED) {
      dispatch(deleteMeetingAttendee(source.value));
    }
  };
};
